import { render, staticRenderFns } from "./OwnerModuleCard.vue?vue&type=template&id=5529f849&"
import script from "./OwnerModuleCard.vue?vue&type=script&lang=js&"
export * from "./OwnerModuleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports